<div class="container-full has-background-white-bis">
  <div class="container">
    <div class="columns">
      <div class="column">
        <app-breadcrumb></app-breadcrumb>
      </div>
    </div>
  </div>
</div>

<section *ngIf="incentive" class="hero is-primary mt-4 mb-8">
  <div class="container is-fullwidth">
    <div class="columns">
      <div class="column">
        <div class="hero-body px-0 py-8">
          <div class="columns is-multiline">
            <div class="column is-12">
              <div
                class="is-flex is-align-items-center is-justify-content-flex-start"
              >
                <a
                  routerLink="/countries/{{ incentive.country.id }}"
                  class="button is-circle is-info mr-3"
                >
                  <i class="fa-solid fa-left-long"></i>
                </a>

                <img
                  class="flag mr-3"
                  src="./assets/images/flags/{{ incentive.country.image }}.png"
                  alt="{{ incentive.country.label }} flag"
                  routerLink="/countries/{{ incentive.country.id }}"
                />
                <h1 class="title is-2 has-text-weight-bold">
                  {{ incentive.label }}
                  <span
                    *ngIf="incentive.country.label === 'Cyprus'"
                    class="has-tooltip has-tooltip-bottom has-tooltip-multiline has-tooltip-large"
                    [attr.data-tooltip]="cyprusNote"
                  >
                    <i
                      class="fa-solid fa-circle-info is-size-5 has-text-link ml-2"
                    ></i>
                  </span>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="container">
  <div class="columns">
    <div class="column is-12">
      <div id="accordion--incentive" class="mb-4">
        <ng-container *ngFor="let theme of themes">
          <div
            class="accordion-header py-4 is-flex is-align-items-center is-justify-content-space-between"
            *ngIf="theme.fields?.length || theme.subThemes?.length"
            (click)="theme.isCollapsed = !theme.isCollapsed"
          >
            <h2 class="title is-4 has-text-weight-bold mb-0">
              {{ theme.label }}
            </h2>
            <a class="button is-primary-light is-circle is-large">
              <i
                class="fa-solid"
                [ngClass]="{
                  'fa-angle-down': theme.isCollapsed,
                  'fa-angle-up': !theme.isCollapsed
                }"
              ></i>
            </a>
          </div>
          <div
            class="is-collapsible"
            [ngClass]="{ 'is-active': !theme.isCollapsed }"
          >
            <div class="table-container is-fullwidth">
              <!-- Theme fields -->
              <table class="table is-fullwidth is-narrow">
                <tbody class="tbody">
                  <ng-container *ngFor="let subTheme of theme.subThemes">
                    <tr class="has-background-white-ter">
                      <td width="280">
                        <strong>{{ subTheme.label }}</strong>
                      </td>
                      <td></td>
                    </tr>
                    <tr *ngFor="let subField of subTheme.fields">
                      <td
                        width="280"
                        class="has-tooltip-right has-tooltip-multiline"
                        [attr.data-tooltip]="subField.description"
                      >
                        <strong>{{ subField.label }}</strong>
                      </td>
                      <td *ngIf="incentive?.values[subField.id]">
                        {{ incentive?.values[subField.id] }}
                      </td>
                      <td *ngIf="!incentive?.values[subField.id]">-</td>
                    </tr>
                  </ng-container>

                  <tr
                    class="has-background-white-ter"
                    *ngIf="theme.fields?.length && theme.subThemes?.length"
                  >
                    <td width="280">
                      <strong>Other</strong>
                    </td>
                    <td></td>
                  </tr>
                  <tr *ngFor="let field of theme.fields">
                    <td
                      width="280"
                      class="has-tooltip-right has-tooltip-multiline"
                      [attr.data-tooltip]="field.description"
                    >
                      <strong>{{ field.label }}</strong>
                    </td>
                    <td *ngIf="incentive?.values[field.id]">
                      {{ incentive?.values[field.id] }}
                    </td>
                    <td *ngIf="!incentive?.values[field.id]">-</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<!-- Spinner -->
<div class="spinner container" *ngIf="!incentive">
  <div class="columns">
    <div class="column is-12">
      <div
        class="accordion-header py-4 is-flex is-align-items-center is-justify-content-space-between"
      >
        <div class="spinner--h5" style="width: 230px"></div>
        <div class="spinner--circle"></div>
      </div>

      <div
        class="accordion-header py-4 is-flex is-align-items-center is-justify-content-space-between"
      >
        <div class="spinner--h5" style="width: 230px"></div>
        <div class="spinner--circle"></div>
      </div>
      <div
        class="accordion-header py-4 is-flex is-align-items-center is-justify-content-space-between"
      >
        <div class="spinner--h5" style="width: 230px"></div>
        <div class="spinner--circle"></div>
      </div>
      <div
        class="accordion-header py-4 is-flex is-align-items-center is-justify-content-space-between"
      >
        <div class="spinner--h5" style="width: 230px"></div>
        <div class="spinner--circle"></div>
      </div>
      <div
        class="accordion-header py-4 is-flex is-align-items-center is-justify-content-space-between"
      >
        <div class="spinner--h5" style="width: 230px"></div>
        <div class="spinner--circle"></div>
      </div>
      <div
        class="accordion-header py-4 is-flex is-align-items-center is-justify-content-space-between"
      >
        <div class="spinner--h5" style="width: 230px"></div>
        <div class="spinner--circle"></div>
      </div>
    </div>
  </div>
</div>

<div class="container mb-4" *ngIf="incentive?.similarIncentiveIds.length">
  <div class="columns is-multiline">
    <div class="column is-12">
      <div class="card is-fullwidth has-background-white-bis">
        <div class="card-content">
          <a
            routerLink="/incentives"
            [queryParams]="{
              similarTo: incentive.id
            }"
            class="is-flex is-align-items-flex-start is-justify-content-flex-start"
          >
            <i class="fa-solid fa-layer-group mr-2 similar-icon"></i>
            Compare with similar incentives</a
          >
        </div>
      </div>
    </div>
  </div>
</div>
